import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable @repo/internal/react/no-clone-element */
import { cloneElement, Component } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import toItemId from '../../utils/to-item-id';
import Items from './items';
var Item = /*#__PURE__*/function (_Component) {
  _inherits(Item, _Component);
  var _super = _createSuper(Item);
  function Item() {
    _classCallCheck(this, Item);
    return _super.apply(this, arguments);
  }
  _createClass(Item, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
        depth = _this$props.depth,
        data = _this$props.data,
        render = _this$props.render,
        loadingLabel = _this$props.loadingLabel;
      var renderedRow = render(data);
      if (!renderedRow) {
        return null;
      }
      var _renderedRow$props = renderedRow.props,
        itemId = _renderedRow$props.itemId,
        items = _renderedRow$props.items;
      return /*#__PURE__*/cloneElement(renderedRow, {
        depth: depth,
        data: data,
        loadingLabel: loadingLabel,
        renderChildren: function renderChildren() {
          return jsx("div", {
            id: toItemId(itemId)
          }, jsx(Items, {
            parentData: data,
            depth: depth,
            items: items,
            render: render,
            loadingLabel: loadingLabel
          }));
        }
      });
    }
  }]);
  return Item;
}(Component);
_defineProperty(Item, "defaultProps", {
  depth: 0
});
export { Item as default };